


import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { getUyeItemData } from "../../../features/admin2/admin2Slice";
import { MdMoreHoriz } from "react-icons/md";
import { showModal } from "../../../features/modal/modalSlice";
import { MdContentCopy } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { FaExclamation } from "react-icons/fa6";
import moment from "moment";


const Container = styled.table`
        width: 100%;
        border-collapse: collapse;

        thead{
            margin-bottom: 20px;
            border-bottom: 10px solid ${({theme}) => theme.mainBgColor};


            th{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-lg);
            }

        }

        tbody{


            tr{
                border-bottom: 20px solid ${({theme}) => theme.mainBgColor};
                background-color: ${({theme}) => theme.secondaryBgColor};
                cursor: pointer;
                td{
                    text-align: center;
                    padding: 15px;
                    font-size: var(--font-size-sm);
                    font-weight: var(--font-weight-md);

                    .more-icon{
                        font-size: 1.4rem;
                        color: ${({theme}) => theme.mainTextColor};
                    }
                }

                .tckn-status-red{
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: var(--color-main);
                    font-size: 15px;
                    color: white;
                }

                .tckn-status-green{
                    width: 25px;
                    height: 25px;
                    border-radius: 50%;
                    background-color: var(--color-green);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 15px;
                    color: white;
                }

            }
        }
`;

const titles = [
  "Kayıt Tarihi",
  "Cep Telefonu",
  "Adı Soyadı",
  "TC No",
  "",
  "İl/İlçe",
  "Kaydeden",
  "Uygulama Versiyon",
  "İşlem",
];

const UyelerTable = ({ list }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();
  return (
    <Container>
      <thead>
          <tr>
              {
                  titles.map((item) => (
                      <th>{item}</th>
                  ))
              }
          </tr>
      </thead>
      <tbody>
          {
              list.map((item) => (
                  <tr onClick={() => {dispatch(showModal("adminUyeDetay")); dispatch(getUyeItemData(item))}}>
                        <td>{moment(item?.createdOn).format('LLL')}</td>
                      <td>
                          <div>
                            <MdContentCopy className="copy-icon" onClick={(e)=>{e.stopPropagation(); navigator.clipboard.writeText(item.phoneNumber); }}/>{item.phoneNumber}</div>
                      </td>
                      <td>{item.adSoyadUnvan || "-"}</td>
                      <td>{item.tckn || "-"}</td>
                      <td>
                          <div  onClick={(e) => {e.stopPropagation(); dispatch(showModal("adminUyeTCDogrula")); dispatch(getUyeItemData(item))}} className={item.isTcNoValid ? "tckn-status-green" : "tckn-status-red"}>{item.isTcNoValid ? <FaCheck /> : <FaExclamation />}</div>
                      </td>
                      <td>{(item.il && item.ilce) ?  `${item.il}/${item.ilce}` :  "-"}</td>
                      <td>-</td>
                      <td>{!item.appVersionNumber ? "-" : item.appVersionNumber}</td>
                      <td>
                          <MdMoreHoriz className="more-icon"  onClick={(e) => {
                              e.stopPropagation();
                              dispatch(getUyeItemData(item));
                              dispatch(showModal("adminUyeOptions"));
                            }}
                          />
                      </td>
                  </tr>
              ))
          }
      </tbody>
    </Container>


    // <Container theme={theme} onClick={() => {dispatch(showModal("adminUyeDetay")); dispatch(getUyeItemData(data))}}>
    //   <div className="container">
    //     <div className="content">
    //       <div
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           dispatch(getUyeItemData(data));
    //           dispatch(showModal("adminUyeOptions"));
    //         }}
    //         className="detay"
    //       >
    //         <MdMoreHoriz className="more-icon"/>
    //       </div>
    //       <div className="row">
    //         <div className="col"><MdContentCopy className="copy-icon" onClick={(e)=>{e.stopPropagation(); navigator.clipboard.writeText(data.phoneNumber); dispatch(addNotify({
    //             message: `Panoya Kopyalandı.`,
    //             type:"success",
    //             name:"nakliyeFiyatHesaplamaDecGun",
    //             duration:1
    //         }))}}/>{data.phoneNumber}</div>
    //         <div className="col">{data.adSoyadUnvan}</div>
    //         <div className="col">{data.tckn}</div>
    //         <div className="col">{data.il} / {data.ilce}</div>
    //         <div className="col">-</div>
    //         <div className="col">{!data.appVersionNumber ? "-" : data.appVersionNumber}</div>
    //       </div>
    //     </div>
    //   </div>
    // </Container>
  );
};

export default UyelerTable;